
export default function IconMuite() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"      
    >
      <g id="SpeakerSimpleX">
        <g id="Vector">
          <path
            d="M19.4375 3.48495C19.2694 3.40357 19.082 3.37101 18.8964 3.39097C18.7109 3.41092 18.5346 3.48258 18.3875 3.59786L9.65 10.4097H4C3.46957 10.4097 2.96086 10.6212 2.58579 10.9976C2.21071 11.3741 2 11.8846 2 12.4169V20.4457C2 20.978 2.21071 21.4886 2.58579 21.865C2.96086 22.2414 3.46957 22.4529 4 22.4529H9.65L18.3875 29.2648C18.5619 29.403 18.7777 29.4781 19 29.478C19.1513 29.4762 19.3004 29.442 19.4375 29.3777C19.6063 29.2952 19.7485 29.1668 19.848 29.0071C19.9475 28.8474 20.0001 28.6628 20 28.4744V4.38819C20.0001 4.19983 19.9475 4.01523 19.848 3.8555C19.7485 3.69577 19.6063 3.56736 19.4375 3.48495Z"
            // fill="#1C1C1C"
            fill="rgba(155, 155, 155, 1)"
          ></path>
          <path
            d="M28.4125 16.4313L30.7125 14.1356C30.872 13.9406 30.9535 13.693 30.9411 13.4411C30.9288 13.1891 30.8235 12.9508 30.6458 12.7724C30.4681 12.594 30.2306 12.4884 29.9795 12.476C29.7285 12.4636 29.4818 12.5454 29.2875 12.7055L27 15.0137L24.7125 12.7055C24.5182 12.5454 24.2716 12.4636 24.0205 12.476C23.7694 12.4884 23.532 12.594 23.3542 12.7724C23.1765 12.9508 23.0712 13.1891 23.0589 13.4411C23.0466 13.693 23.128 13.9406 23.2875 14.1356L25.5875 16.4313L23.2875 18.727C23.0997 18.9173 22.9944 19.1743 22.9944 19.4421C22.9944 19.7099 23.0997 19.9669 23.2875 20.1571C23.4795 20.3413 23.7345 20.4446 24 20.4457C24.2651 20.4421 24.5192 20.3392 24.7125 20.1571L27 17.8489L29.2875 20.1571C29.4795 20.3413 29.7345 20.4446 30 20.4457C30.2651 20.4421 30.5192 20.3392 30.7125 20.1571C30.9003 19.9669 31.0056 19.7099 31.0056 19.4421C31.0056 19.1743 30.9003 18.9173 30.7125 18.727L28.4125 16.4313Z"
            // fill="#1C1C1C"
            fill="rgba(155, 155, 155, 1)"
          ></path>
        </g>
      </g>
    </svg>
  );
}
